// Angular
import { ChangeDetectionStrategy, Component, inject, OnInit, signal, DestroyRef, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Material
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
// Service
import { AuthService } from '@auth-service';
import { CommonService, GlobalErrorHandler } from '@core/utils';
// RxJs
import { catchError, finalize } from 'rxjs';
// Constant
import { APP_CONSTANT } from '@constants';
// Directive
import { CopyToClipboardDirective } from '@app/core/directives';
// Permission
import { NgxPermissionsModule } from 'ngx-permissions';
// Transloco
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: 'app-login-via-qr',
  templateUrl: './login-via-qr.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatTabsModule, CopyToClipboardDirective, NgxPermissionsModule, TranslocoDirective,MatRadioModule]
})
export class LoginViaQRComponent implements OnInit, OnDestroy {

  // Private
  private readonly dialogRef = inject<MatDialogRef<LoginViaQRComponent>>(MatDialogRef);
  private readonly auth = inject(AuthService);
  private readonly globalErrorHandler = inject(GlobalErrorHandler);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cs = inject(CommonService);

  imageUrl = signal<string | null>(null);
  loading = signal(true); 
  error = signal<string | null>(null);
  setupMode = signal<number>(1);  // 1: Update (Default), 2: Install
  readonly token = signal(this.cs.getFromLocalStorage(APP_CONSTANT.JWT_TOKEN_KEY));

  /**
 * OnInit
 * @memberof UserInfoComponent
 */
  ngOnInit(): void {
    this.auth.getJWTQR().pipe(
      catchError((error) => this.globalErrorHandler.handleError('jwt-qr-code', error)),
      finalize(() => this.loading.set(false)),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: (res) => {
        const body = res.body;
        if ((body instanceof Blob)) {
          // revoke previous URL
          const prev = this.imageUrl();
          if (prev) URL.revokeObjectURL(prev);
          const url = URL.createObjectURL(body);
          this.imageUrl.set(url);
        }
      },
      error: (err) => {
        this.error.set('Failed to load image');
      }
    });
  }

  /**
   * On Destroy
   * @summary To avoid memory leak destroy component subscription
   */
  ngOnDestroy() {
    //  Prevent object URL leak
    const url = this.imageUrl();
    if (url) URL.revokeObjectURL(url);
  }

}